// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2c-Ta","content":"styles_content__1bSu5","selectAll":"styles_selectAll__2BIrB"};